import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useTranslation } from '../../../application/hooks/useTranslation';
import './BookingLockNotice.css';

/** Shown in place of a payment flow while the booking is unverified (direct URLs, deep links). */
export function BookingLockNotice() {
  const { t } = useTranslation();
  return (
    <div className="booking-lock" role="status" data-testid="booking-lock">
      <Lock size={22} aria-hidden />
      <h2>{t('payments.locked.title')}</h2>
      <p>{t('payments.locked.body')}</p>
      <Link to="/" className="booking-lock-back">{t('payments.locked.back')}</Link>
    </div>
  );
}
